import { useGetRecordQuery } from "@/components/record/services/recordApi";
import { useParams } from "react-router-dom";

export const useGetRecordQueryCtx = () => {
  const { recordId } = useParams();
  const record = useGetRecordQuery(
    { expediente_id: recordId! },
    {
      skip: !recordId,
      refetchOnReconnect: true,
      refetchOnMountOrArgChange: 60,
    }
  );
  return { ...record, recordId };
};
